window.onload = function(){
  var linkmsg=document.getElementById("linkmsg");
  linkmsg.style.visibility="hidden";
  sizemsg.style.visibility="hidden";
  haisen_position.style.visibility="hidden";
  panel_choice.style.visibility="hidden";
  op_psimsg.style.display="none";
  document.getElementById("material").innerHTML = "選択してください";
  document.getElementById("width").value="";
  document.getElementById("depth").value="";
  document.getElementById("height").value="";
  document.getElementById("price").value="";
  var cancel = document.getElementsByName('color_main');
  for (const i of cancel) {i.checked = false;}
  var cancel2 = document.querySelectorAll(`input[type='checkbox']`);
  for (const i of cancel2) {i.checked = false;}
  var cancel3 = document.querySelectorAll(`input[type='radio']`);
  for (const i of cancel3) {i.checked = false;}
  cartReset();resizing();
}
window.onresize = function(){resizing();}

//リサイズ
function resizing(){
 var size_acquisition = document.getElementById("size_img");
 var wsize = size_acquisition.clientWidth;
 $("#size_img img").css("width",wsize+"px");
 var size_acquisition = document.getElementById("demoimg");
 var hsize = size_acquisition.clientHeight;
 $("#size_img").css("height",hsize+"px");
}

//カート中身リセット
function cartReset(){
    document.getElementById("price").value=""
    cart_price.innerHTML =""+" 円";
    cart_width.innerHTML=""; 
    cart_depth.innerHTML=""; 
    cart_height.innerHTML="";
    cart_color.innerHTML="";
    cart_option.innerHTML="";
    cart_opprice.innerHTML="";
    linkmsg.style.visibility="hidden";
}

//リアルタイムサイズチェック
function changeMsg(){
    var intDepth=document.getElementById("depth").value;
    var intWidth=document.getElementById("width").value;
    var intHeight=document.getElementById("height").value;
    sizemsg.style.visibility="hidden";
    cartReset();
    if (intDepth==""||intWidth==""||intHeight==""){
        document.getElementById("sizemsg").innerHTML = "<p> </p>";
     sizemsg.style.visibility="hidden";
        return false;
    }
    if (intWidth < 20 || intWidth > 180){document.getElementById("sizemsg").innerHTML = "<p>※ 幅20cm未満・幅181cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intDepth < 10 || intDepth > 30){document.getElementById("sizemsg").innerHTML = "<p>※ 奥行10cm未満・奥行31cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intHeight < 10 || intHeight > 45){document.getElementById("sizemsg").innerHTML = "<p>※ 高さ10cm未満・高さ46cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intHeight < intDepth){document.getElementById("sizemsg").innerHTML = "<p>※ 高さを超える奥行はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    document.getElementById("sizemsg").innerHTML = "<p> </p>"
    
 sizemsg.style.visibility="hidden";
}

//材質切替
function materialWood(){document.getElementById("material").innerHTML = "リーズナブル木目：<br class=\"delete\">[材質]プリント化粧合板";}
function materialAino(){document.getElementById("material").innerHTML = "パステルカラーaino：<br class=\"delete\">[材質]強化紙化粧合板";}
function materialMela(){document.getElementById("material").innerHTML = "ハイグレード鏡面仕上げ：<br class=\"delete\">[材質]メラミン樹脂化粧合板";}

//オプション
function changeOp(){
    checkBoxhaisen = document.frm_detail.op_haisen.checked;
    haisen_position.style.visibility="hidden";
    panel_choice.style.visibility="hidden";
    linkmsg.style.visibility="hidden";
    if (checkBoxhaisen==true){
     haisen_position.style.visibility="visible";
     panel_choice.style.visibility="visible";
     cartReset();
     return false;
    }
    var cancel = document.frm_detail.op_panel
    for (const i of cancel) {i.checked = false;}
    op_psimsg.style.display="none";
    cartReset();
}

function choicePanel(selectPanel){
  op_psimsg.style.display="block";
  document.querySelector("#op_psimsg > p > span:nth-child(1)").innerHTML = "";
  switch(selectPanel){
    case 0:
      document.querySelector("#op_psimsg > p > span:nth-child(1)").innerHTML = "板面：Aを正面から見て<br><img src=\"https://www.rakuten.ne.jp/gold/arne/size_order/images/wb/cftype/panel_choice-a.png\"><br>";
      $('#hole_ichi > option').remove();
      $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
      $('#hole_ichi').append($('<option>').html("穴位置：左上").val("左上"));
      $('#hole_ichi').append($('<option>').html("穴位置：左下").val("左下"));
      $('#hole_ichi').append($('<option>').html("穴位置：中央上").val("中央上"));
      $('#hole_ichi').append($('<option>').html("穴位置：中央下").val("中央下"));
      $('#hole_ichi').append($('<option>').html("穴位置：右上").val("右上"));
      $('#hole_ichi').append($('<option>').html("穴位置：右下").val("右下"));
      break;
    case 1:
      document.querySelector("#op_psimsg > p > span:nth-child(1)").innerHTML = "板面：Bを側面から見て<br><img src=\"https://www.rakuten.ne.jp/gold/arne/size_order/images/wb/cftype/panel_choice-b.png\"><br>";
      $('#hole_ichi > option').remove();
      $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
      $('#hole_ichi').append($('<option>').html("穴位置：左上").val("左上"));
      $('#hole_ichi').append($('<option>').html("穴位置：左下").val("左下"));
      $('#hole_ichi').append($('<option>').html("穴位置：右上").val("右上"));
      $('#hole_ichi').append($('<option>').html("穴位置：右下").val("右下"));
      break;
    case 2:
      document.querySelector("#op_psimsg > p > span:nth-child(1)").innerHTML = "板面：Cを側面から見て<br><img src=\"https://www.rakuten.ne.jp/gold/arne/size_order/images/wb/cftype/panel_choice-c.png\"><br>";
      $('#hole_ichi > option').remove();
      $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
      $('#hole_ichi').append($('<option>').html("穴位置：左上").val("左上"));
      $('#hole_ichi').append($('<option>').html("穴位置：左下").val("左下"));
      $('#hole_ichi').append($('<option>').html("穴位置：右上").val("右上"));
      $('#hole_ichi').append($('<option>').html("穴位置：右下").val("右下"));
      break;
    case 3:
      document.querySelector("#op_psimsg > p > span:nth-child(1)").innerHTML = "板面：Dを下から見て<br><img src=\"https://www.rakuten.ne.jp/gold/arne/size_order/images/wb/cftype/panel_choice-d.png\"><br>";
      $('#hole_ichi > option').remove();
      $('#hole_ichi').append($('<option>').html("穴位置を選択してください").val("穴位置を選択してください"));
      $('#hole_ichi').append($('<option>').html("穴位置：左上").val("左上"));
      $('#hole_ichi').append($('<option>').html("穴位置：左下").val("左下"));
      $('#hole_ichi').append($('<option>').html("穴位置：中央上").val("中央上"));
      $('#hole_ichi').append($('<option>').html("穴位置：中央下").val("中央下"));
      $('#hole_ichi').append($('<option>').html("穴位置：右上").val("右上"));
      $('#hole_ichi').append($('<option>').html("穴位置：右下").val("右下"));
      break;
  }
  cartReset();
}

//サイズオーダー
const strLink1="<a href=\"https://item.rakuten.co.jp/arne-style/"
const strLink2="\" target=\"_blank\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,width,depth,height,color){
this.url=url;this.width=width;this.depth=depth;this.height=height;this.color=color;}

function searchURL(strWidth,strDepth,strHeight,strColor){
  var strErr;
  var intWidth=document.getElementById("width").value
  var intDepth=document.getElementById("depth").value
  var intHeight=document.getElementById("height").value

  //サイズチェック
  if (intWidth < 20 || intWidth > 180){strErr="幅20cm未満・幅181cm以上は";}
  else if (intDepth < 10 || intDepth > 30){strErr="奥行10cm未満・奥行31cm以上は";}
  else if (intHeight < 10 || intHeight > 45){strErr="高さ10cm未満・高さ46cm以上は";}
  else if (intHeight < intDepth){strErr="高さを超える奥行は";}
  if(strErr){document.getElementById("price").value="";
  return strErr+"オーダー不可です。";}

  //幅サイズ成形
  switch(intWidth != null){
    case intWidth <= 20: priceW = 0;break;
    case intWidth <= 25: priceW = 1;break;
    case intWidth <= 30: priceW = 2;break;
    case intWidth <= 35: priceW = 3;break;
    case intWidth <= 45: priceW = 4;break;
    case intWidth <= 60: priceW = 5;break;
    case intWidth <= 90: priceW = 6;break;
    case intWidth <= 120: priceW = 7;break;
    case intWidth <= 180: priceW = 8;break;
  }

  //高さサイズ成形
  switch(intHeight != null){
    case intHeight <= 14: priceH = 0;break;
    case intHeight <= 19: priceH = 5;break;
    case intHeight <= 24: priceH = 10;break;
    case intHeight <= 29: priceH = 15;break;
    case intHeight <= 34: priceH = 20;break;
    case intHeight <= 44: priceH = 25;break;
    case intHeight <= 45: priceH = 30;break;
  }

  //奥行サイズ成形
  switch(intDepth != null){
    case intDepth <= 10: priceD = 0;break;
    case intDepth <= 15: priceD = 1;break;
    case intDepth <= 20: priceD = 2;break;
    case intDepth <= 24: priceD = 3;break;
    case intDepth <= 30: priceD = 4;break;
  }
  
    var arr = csvToArray("https://cdn.shopify.com/s/files/1/0549/1834/8887/files/wb-cf_price.csv?v=1665133132");
    priceD = priceD+priceH;
    if(strColor == "nail" || strColor == "black"){priceW=priceW+9;}
    else if(strColor == "bp"){priceW=priceW+18;}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){priceW=priceW+27;}
    var sellPrice = arr[priceD][priceW];
    return sellPrice;

  function csvToArray(filename) {

    var srt = new XMLHttpRequest();
    srt.open("GET", filename, false);
    try {
      srt.send(null);
    } catch (err) {
      console.log(err)
    }
    var csvArr = [];
    var lines = srt.responseText.split("\n");
    for (var i = 0; i < lines.length; ++i) {
      var cells = lines[i].split(",");
      if (cells.length != 1) {
        csvArr.push(cells);
      }
    }
    return csvArr;
  }
  
}


//サイズ入力時
function changeSize(){
  var intWidth=document.getElementById("width").value
  var intDepth=document.getElementById("depth").value
  var intHeight=document.getElementById("height").value
  var imgW = "120";
  var imgD = "20";
  var imgH = "30";
  switch(imgW != null){
    case intWidth == "": imgD = "120";break;
    case intWidth <= 40: imgW = "30";break;
    case intWidth <= 80: imgW = "60";break;
    case intWidth <= 140: imgW = "120";break;
    case intWidth <= 180: imgW = "180";break;
    default:imgW = "120";
  }
  switch(imgD != null){
    case intDepth == "": imgD = "20";break;
    case intDepth <= 10: imgD = "10";break;
    case intDepth <= 20: imgD = "20";break;
    case intDepth <= 30: imgD = "30";break;
    default:imgD = "20";
  }
  switch(imgH != null){
    case intHeight == "": imgH = "30";break;
    case intHeight <= 20: imgH = "10";break;
    case intHeight <= 35: imgH = "30";break;
    case intHeight <= 45: imgH = "45";break;
    default:imgH = "30";
  }
  var changeSize = imgW+imgD+imgH;
  var changeImgUrl = $(document.area1).attr("src").split("/");
  var changeImgUrl = $(document.area1).attr("src").replace(changeImgUrl[10] , changeSize);
  $(document.area1).attr("src", changeImgUrl+".png");
  $("#size_img img:nth-of-type(3)").css("display","none");
}

function colorMain(changeImg){
  var colorList = document.getElementsByName("color_main");
  if(changeImg<=13){var chooseColor=colorList[changeImg].id.slice(5);}
  else {var chooseColor=colorList[changeImg].id}

  let imgColor = $(document.area1).attr("src").split("/");
  imgColor = $(document.area1).attr("src").replace(imgColor[9] , chooseColor+"_color");
  $(document.area1).attr('src', imgColor);
}


/*リストから商品URLを取得*/
function checkURL(strWidth,strDepth,strHeight,strColor){
switch(true){
 default:
  for(var i in goods){
if(goods[i].width==strWidth && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].color==strColor){
return goods[i].url;}}
  break;
return false;
}
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
cartReset();      
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=document.getElementById("depth").value;
var strWidth=document.getElementById("width").value;
var strHeight=document.getElementById("height").value;
var idColor = document.getElementsByName("color_main") ;
var strColor = "";
var strOption = "";
var i=0;
var c=0;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
     if( idColor[i].id.slice(0,4)=="wood" ){
         strColor = idColor[i].id.slice(0,4);
     }else if( idColor[i].id.slice(0,4)=="aino" ){
         strColor = idColor[i].id.slice(0,4);
     }else{
         strColor = idColor[i].id;
     }
  var valueColor = idColor[i].value ;
  break ;
 }
}

  var checkBoxhaisen = $("input[name='op_panel']:checked").attr('id');
  var op_position = "";
  switch(checkBoxhaisen){
    case "panel_a":
    op_position = "背板";
    break;
    case "panel_b":
    op_position = "左側板";
    break;
    case "panel_c":
    op_position = "右側板";
    break;
    case "panel_d":
    op_position = "底板";
    break;
  }
  var valueOption = "配線穴は" + op_position + "の" + $("#hole_ichi").val();
  var total = 0;
  if (checkBoxhaisen !== undefined){var total = 1;}


if (isNumber(strWidth)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (isNumber(strDepth)==false){
alert("奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (isNumber(strHeight)==false){
alert("高さは『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (strColor==false){
alert("カラーを選択してください");
return false;
}
var checkBoxhaisen = document.frm_detail.op_haisen.checked;
if(checkBoxhaisen==true && valueOption== "配線穴は" + op_position + "の穴位置を選択してください"){
alert("穴位置を選択してください");
return false;
}else if(checkBoxhaisen==false){var valueOption = "オプション無し"};

document.getElementById("choice1").value=strWidth+"cm"
document.getElementById("choice2").value=strDepth+"cm"
document.getElementById("choice3").value=strHeight+"cm"
document.getElementById("choice4").value=valueColor
document.getElementById("choice5").value=valueOption
//商品ページの有無チェック
var comcode=checkURL(strWidth,strDepth,strHeight,strColor);
if (!comcode=="" && valueOption=="オプション無し"){
  var stock=1;
  if(valueColor == "オーク" || valueColor == "ブラックウッド"){stock = 0}
  var target=document.getElementById("linkmsg");
  linkmsg.style.visibility="visible";
  if(stock == 1){
  target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
  return false;
  }else {target.innerHTML="リーズナブル木目"+valueColor+"は別注色のため金額が異なります。";}
}
var url=searchURL(strWidth,strDepth,strHeight,strColor);

if(!url){
alert("幅、奥行、高さを選んでください");
return false;
}

var intUnit;
if (isNaN(url)==false){
 if(total>0){
     total=total*1500;
 }
 document.getElementById("choice7").value="追加金額：" +total+"/"
 
 intUnit=(parseInt(url)+total)/500;
 document.getElementById("price").value =(parseInt(url)+total).toLocaleString()+" 円";
 cart_price.innerHTML =(parseInt(url)+total).toLocaleString()+" 円";
 cart_width.innerHTML=strWidth;
 cart_depth.innerHTML=strDepth;
 cart_height.innerHTML=strHeight;
 cart_color.innerHTML=valueColor;
 cart_option.innerHTML=valueOption;
 cart_opprice.innerHTML=total;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice6").value="見積もり金額："+(parseInt(url)+total);
return false;
}
function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;
 var choice4=document.frm.choice4.value;
 var choice5=document.frm.choice5.value;
 var choice6=document.frm.choice6.value;
 var choice7=document.frm.choice7.value;
 var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
 if(choice1=="" || choice2=="" || choice3=="") {
     alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
     return false;
 }
 if(price=="") {
     alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
     return false;
 }       
 return true;
}



goods = new Object();
goods[0] =new setGoods("0000a03889","60","21","20","wood");
goods[1] =new setGoods("0000a03907","75","21","20","wood");
goods[2] =new setGoods("0000a04205","60","14","20","wood");
goods[3] =new setGoods("0000a04235","75","14","20","wood");
goods[4] =new setGoods("0000a06291","90","21","20","wood");
goods[5] =new setGoods("0000a06297","120","21","20","wood");
goods[6] =new setGoods("0000a06303","150","21","20","wood");
goods[7] =new setGoods("0000a06309","90","14","20","wood");
goods[8] =new setGoods("0000a06315","120","14","20","wood");
goods[9] =new setGoods("0000a06321","150","14","20","wood");
goods[10] =new setGoods("0000a39020","60","21","20","aino");
goods[11] =new setGoods("0000a39038","75","21","20","aino");
goods[12] =new setGoods("0000a39056","60","14","20","aino");
goods[13] =new setGoods("0000a39074","75","14","20","aino");
goods[14] =new setGoods("0000a39080","90","21","20","aino");
goods[15] =new setGoods("0000a39086","120","21","20","aino");
goods[16] =new setGoods("0000a39092","150","21","20","aino");
goods[17] =new setGoods("0000a39098","90","14","20","aino");
goods[18] =new setGoods("0000a39104","120","14","20","aino");
goods[19] =new setGoods("0000a39110","150","14","20","aino");
goods[20] =new setGoods("0000a55168","75","21","20","nail");
goods[21] =new setGoods("0000a55169","90","21","20","nail");
goods[22] =new setGoods("0000a55170","120","21","20","nail");
goods[23] =new setGoods("0000a55171","150","21","20","nail");
goods[24] =new setGoods("0000a55172","180","21","20","nail");
goods[25] =new setGoods("0000a55183","75","21","20","black");
goods[26] =new setGoods("0000a55184","90","21","20","black");
goods[27] =new setGoods("0000a55185","120","21","20","black");
goods[28] =new setGoods("0000a55186","150","21","20","black");
goods[29] =new setGoods("0000a55187","180","21","20","black");
goods[30] =new setGoods("0000a55198","75","21","20","bp");
goods[31] =new setGoods("0000a55199","90","21","20","bp");
goods[32] =new setGoods("0000a55200","120","21","20","bp");
goods[33] =new setGoods("0000a55201","150","21","20","bp");
goods[34] =new setGoods("0000a55202","180","21","20","bp");
goods[35] =new setGoods("0000a55213","75","21","20","mb");
goods[36] =new setGoods("0000a55214","90","21","20","mb");
goods[37] =new setGoods("0000a55215","120","21","20","mb");
goods[38] =new setGoods("0000a55216","150","21","20","mb");
goods[39] =new setGoods("0000a55217","180","21","20","mb");
goods[40] =new setGoods("0000a55228","75","21","20","gs");
goods[41] =new setGoods("0000a55229","90","21","20","gs");
goods[42] =new setGoods("0000a55230","120","21","20","gs");
goods[43] =new setGoods("0000a55231","150","21","20","gs");
goods[44] =new setGoods("0000a55232","180","21","20","gs");
goods[45] =new setGoods("0000a55243","75","21","20","ww");
goods[46] =new setGoods("0000a55244","90","21","20","ww");
goods[47] =new setGoods("0000a55245","120","21","20","ww");
goods[48] =new setGoods("0000a55246","150","21","20","ww");
goods[49] =new setGoods("0000a55247","180","21","20","ww");
goods[50] =new setGoods("0000a55266","180","21","20","wood");

